import React from 'react';
import { ISerpPlugin } from '~/plugins/SerpPlugin';
import { App } from './App';
import { RootContexts } from './contexts';
import { Configuration } from './core/configuration/configuration.type';
import { DynamicComponents } from './plugins/dynamicComponents/dynamicComponents';

interface AppContainerProps {
    config: Configuration;
    debug: boolean;
    plugin: ISerpPlugin | null;
    /** used for loading plugin components */
    dynamicComponents: DynamicComponents;
}

export const AppContainer: React.FC<AppContainerProps> = ({ config, debug, plugin, dynamicComponents }) => {
    return (
        <React.StrictMode>
            <RootContexts debug={debug} plugin={plugin} config={config} dynamicComponents={dynamicComponents}>
                <App />
            </RootContexts>
        </React.StrictMode>
    );
};
